module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAFVBMVEVHcEz///////////////////////+3ygHaAAAAB3RSTlMASe7dOf/20qndQgAAADpJREFUeNrF0jEOACAMAkALbf//ZEcnGDSxrJewwJpMgCkRVR0KWUazHxSDSou29p/1nfnJcEzdZD4bKiMB/XBq124AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/detail-right-arrow.png
// module id = bsq+
// module chunks = 213